import { CartItem } from '@/types/cart.types';

export function getDuplicatedCartItemIds(items: CartItem[]): ReadonlySet<string> {
  const idsByPatientProcedure = new Map<string, string[]>();

  items.forEach((item) => {
    const key = [item.patient.id, item.procedure.id].join('|');
    const cartItemIds = idsByPatientProcedure.get(key) ?? [];

    cartItemIds.push(item.id);
    idsByPatientProcedure.set(key, cartItemIds);
  });

  const duplicatedIds = new Set<string>();

  idsByPatientProcedure.forEach((cartItemIds) => {
    if (cartItemIds.length > 1) {
      cartItemIds.forEach((cartItemId) => duplicatedIds.add(cartItemId));
    }
  });

  return duplicatedIds;
}
